import { mobilityService } from "@lg-cfa/services";
import { useEffect } from "react";
import { useRecoilState } from "recoil";

import { useFlowNavigation } from "../useFlowNavigation";

import { PageNames } from "@enums";
import { businessRulesState } from "@states";

export function useBusinessRules() {
    const isSSR = typeof window === "undefined";
    const [businessRules, setBusinessRules] =
        useRecoilState(businessRulesState);
    const { navigateTo } = useFlowNavigation();

    useEffect(() => {
        if (!isSSR && !businessRules) {
            mobilityService
                .getBusinessRules()
                .then((r) => {
                    setBusinessRules(r);
                })
                .catch((error) => {
                    console.error(error);
                    navigateTo(PageNames.TechnicalDifficulties);
                });
        }
        // eslint-disable-next-line
    }, [isSSR, businessRules, setBusinessRules]);

    return businessRules;
}
